import { useApiMaterialV1MaterialProductsDelete } from 'api';
import { UseFormReturn } from 'form';
import { useNavigate } from 'react-router-dom';

import { UpdateFormValues } from '../../pages/MaterialProductDetails/MaterialProductDetails';
import { MaterialProductFormValues } from '../../pages/schema';
import { handleError } from '../../utils/handleFormError/handleFormError';

export const useDeleteMaterialProduct = (form: UseFormReturn<MaterialProductFormValues, unknown, UpdateFormValues>) => {
  const { setError } = form;
  const navigate = useNavigate();
  return useApiMaterialV1MaterialProductsDelete({
    mutation: {
      onError: (error) => {
        handleError(error, setError);
      },
      onSuccess: () => {
        navigate(`/ground-control/material-products/`);
      },
    },
  });
};
